import type { AgentProgressEvent } from '~/components/AiChat/AgentTimeline/types';
import { getProgressMetadata } from '~/components/ProgressTimeline/progressTimelineUtils';
import { PROGRESS_EVENT_KIND } from '~/components/ProgressTimeline/types';

import type { DocumentProgressMetadata } from './documentProgressTypes';

export const metaOf = (event: AgentProgressEvent): DocumentProgressMetadata =>
  getProgressMetadata<DocumentProgressMetadata>(event);

/** The key a document row matches its events by: the external id the AI service was sent. */
export const progressKeyOf = (event: AgentProgressEvent): string | undefined => {
  const meta = metaOf(event);
  return meta.document_external_id ?? meta.doc_task_id;
};

/** The latest `plan` event per document in `events`, merged over `previous`; `previous` itself when none is newer. */
export const mergeLatestPlans = (
  events: AgentProgressEvent[],
  previous: Map<string, AgentProgressEvent>
): Map<string, AgentProgressEvent> => {
  let merged: Map<string, AgentProgressEvent> | undefined;
  events.forEach((event) => {
    const key = progressKeyOf(event);
    if (!key || metaOf(event).kind !== PROGRESS_EVENT_KIND.PLAN) return;
    const known = (merged ?? previous).get(key);
    if (known && known.timestamp >= event.timestamp) return;
    merged = merged ?? new Map(previous);
    merged.set(key, event);
  });
  return merged ?? previous;
};
